module.exports = __webpack_public_path__ + "img/1-3.2ee7790b.png";